/**
 * Riconoscimento dei collegamenti `.url` dal nome.
 *
 * La regola vive anche lato server (`lib/shortcut.ts`), ed e' li' che decide:
 * l'endpoint rifiuta qualunque file che non sia un collegamento, e valida lo
 * schema della destinazione. Questa copia serve solo a disegnare la riga —
 * icona a catena, nome cliccabile — senza chiedere niente al server per ogni
 * elemento della cartella. Se le due divergono, il peggio che succede e' una
 * riga disegnata male: l'apertura la decide comunque il server.
 */
export function isShortcut(name: string): boolean {
  return name.toLowerCase().endsWith('.url');
}
